<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->

    <!-- /.content-header -->

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">جدول نظرات</h3>
                <div class="card-tools">
                  <div class="input-group input-group-sm insert_box">
                  
                  </div>
                </div>
              </div>
              <template v-if="!status">
                <div v-if="Items" class="card-body table-responsive p-0">
                  <table v-if="bookList.length>0" class="table table-hover">
                    <tr>
                      <th>
                        نظرات
                      </th>
                      <th>
                        کتاب
                      </th>
                      <th>
                        تنظیمات
                      </th>
                    </tr>
                    <tr v-for="item in Items" :key="item.id">
                      <td   :class="{'success':item.approved==1,'warning':item.approved==0}">
                        {{ item.comment }}
                      </td>
                      <td>
                        {{getBook(item.book_id)}}
                      </td>
                      <td>
                        <b-button
                        v-if="item.approved==0"
                          class="tableButtons"
                          variant="primary"
                          @click="acceptComment(item.id, 1)"
                          >تایید</b-button
                        >
                        <b-button
                        v-else
                          class="tableButtons"
                          variant="danger"
                          @click="acceptComment(item.id, 0)"
                          >عدم تایید</b-button
                        >
                        <b-button
                   
                          class="tableButtons"
                          variant="warning"
                          @click="deleteComment(item.id)"
                          >حذف</b-button
                        >
                      </td>
                    </tr>
                  </table>
                </div>
              </template>
              <!-- /.card-header -->

              <!-- /.card-body -->
              <!-- <div class="card-footer">
                <b-button variant="warning"
                 @click="showDraggableTable()"
                >
الویت بندی
                </b-button>
              </div> -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        <div class="d-flex justify-content-center" v-if="!status">
          <pagination
            v-if="fullData != null"
            :data="fullData"
            @pagination-change-page="changePage"
            :disabled="status"
          ></pagination>
        </div>
      </div>
    </section>
    <Loading :show_loading="status" />

    <!-- /.content -->
  </div>
</template>
<script>
import Loading from "@/components/admin/loading.vue";
import mixin from "../../mixins/mixins";
import { BFormInput, BButton } from "bootstrap-vue";
export default {  metaInfo() {
    return {
      title: " دیدگاه ها",
    }
  },
  components: {
    Loading,
    BFormInput,
    BButton
  },
  mixins: [mixin],
  data() {
    return {
      bookList:[],
      searchName: null,
      routeKey: "comments",
      current_url: "/admin/comments"
    };
  },
  created() {
    this.$axios.get("/admin/books?all=1").then(res =>{
      this.bookList=this.$root.fillCategorySelectOption(res.data.data.books,'children','title')
    })
    if (this.Items == null) {
      this.getItemsFromServer(
        this.current_url,
        this.$route.query.page != undefined ? this.$route.query.page : "1",
        false,
        "",
        this.routeKey
      );
    }
  },
  methods: {
    deleteComment(id){
        window
        .swal({
          title: "آیا از پاک کردن مطمئن هستید",
          text: "این عمل قابل بازگشت نیست",
          icon: "warning",

          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["نه", "  بله "]
        })
        .then((willDelete) => {
          if (willDelete) {
            this.$axios
              .delete(this.current_url + `/${id}`)
              .then((response) => {
                this.getItemsFromServer(
        this.current_url,
        this.$route.query.page != undefined ? this.$route.query.page : "1",
        false,
        "",
        this.routeKey
      );
                window.swal({
                  icon: "success",
                  showConfirmButton: true,
                  text: response.data.message,
                  button: "OK"
                });
              })
              .catch((error) => {
                window.swal({
                  title: "ERROR",
                  showConfirmButton: true,
                  text: error.response.data.message,
                  button: "OK"
                });
              });
          }
        });
    },
    showPostModal() {
      this.mode = "create";

      // this.$bvModal.show("postModal");
      this.showpModal = true;
    },
    getBook(id){
let ans="";
this.bookList.forEach((book)=>{
  if(book.id==id){
    return ans=book.label
  }
})
return ans
    },
    acceptComment(id, flag) {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("status", flag);
      this.$axios.post("/admin/comments/approve", formData).then((res) => {
        this.$root.notify(res.data.message, "success");
        this.Items.forEach(element => {
          if(element.id==id){
            element.approved=flag
          }
        });
      });
    }
  },
  watch: {
    searchName(newVal) {
      if (newVal == null || newVal == "" || newVal == " ") {
        this.$router.replace({ name: "publisher", query: { page: "1" } });
      } else {
        this.getItemsFromServer(
          this.current_url,
          1,
          true,
          `&searchBy1=name&search1=${newVal}`,
          this.routeKey
        );
      }
    }
  }
};
</script>
<style scoped>
.tableButtons {
  margin-right: 10px;
}
.warning{
  color: rgb(255, 0, 0);
}.success{
  color:green
}
</style>
